import { render, staticRenderFns } from "./SettingsConfig.vue?vue&type=template&id=231eeaf2"
import script from "./SettingsConfig.vue?vue&type=script&lang=js"
export * from "./SettingsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports